import { InventoryMeterMountType } from '@enmon/commons/lib/tools/api/inventory-meter';
import { OutputTechnology as CommonsOutputTechnology } from '@enmon/commons/lib/tools/types';

export const remoteReadingMountTypeOptions: Array<{
  description: string;
  label: string;
  value: InventoryMeterMountType;
}> = [
  {
    description: 'No remote-reading module, mount, output, or interface is visibly installed.',
    label: 'Free',
    value: InventoryMeterMountType.Free,
  },
  {
    description: 'Remote-reading output or mount exists, but it is not occupied by an active reader.',
    label: 'Installed - free',
    value: InventoryMeterMountType.MountedFree,
  },
  {
    description: 'Remote-reading module/device is already mounted and in use.',
    label: 'Installed - occupied',
    value: InventoryMeterMountType.MountedOccupied,
  },
];

export const outputTechnologyOptions: Array<{ label: string; value: CommonsOutputTechnology }> = [
  ...Object.values(CommonsOutputTechnology).map(value => ({
    label: formatOutputTechnologyLabel(value),
    value,
  })),
];

function formatOutputTechnologyLabel(value: CommonsOutputTechnology) {
  return value
    .replace(/_/g, ' ')
    .replace(/\bOPTICAL\b/g, 'optical')
    .replace(/\bRS(\d+)\b/g, 'RS$1');
}
